(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deepmoat-memory-archive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const initialize = (root) => {
      if (root.dataset.dmmaInitialized) return;
      const search = root.querySelector('[data-dmma-search]');
      const controls = root.querySelector('[data-dmma-controls]');
      const status = root.querySelector('[data-dmma-status]');
      const empty = root.querySelector('[data-dmma-empty]');
      const expand = root.querySelector('[data-dmma-expand]');
      const yearButtons = [...root.querySelectorAll('[data-dmma-year]')];
      const years = [...root.querySelectorAll('[data-dmma-year-group]')].map((element) => ({
        element,
        year: element.dataset.dmmaYearGroup,
        months: [...element.querySelectorAll('[data-dmma-month]')].map((month) => ({
          element: month,
          entries: [...month.querySelectorAll('[data-dmma-entry]')].map((element) => ({
            element,
            title: normalize(element.dataset.title),
            source: normalize(element.dataset.source)
          }))
        }))
      }));
      if (!search || !controls || !status || !empty || !expand) return;
      root.dataset.dmmaInitialized = 'true';
      const total = years.reduce((count, year) => count + year.months.reduce((sum, month) => sum + month.entries.length, 0), 0);
      let selectedYear = 'all';
      let previousQuery = '';
      const visibleDetails = () => [...root.querySelectorAll('[data-dmma-year-group], [data-dmma-month]')].filter((element) => !element.hidden && !element.closest('[hidden]'));
      const syncExpand = () => {
        const details = visibleDetails();
        const allOpen = details.length > 0 && details.every((element) => element.open);
        expand.textContent = allOpen ? root.dataset.collapseMessage : root.dataset.expandMessage;
        expand.setAttribute('aria-expanded', String(allOpen));
        expand.disabled = details.length === 0;
      };
      const apply = (restore = false) => {
        const query = normalize(search.value);
        const clearDisclosure = restore || (previousQuery !== '' && query === '');
        let shown = 0;
        years.forEach((year) => {
          const yearMatches = selectedYear === 'all' || selectedYear === year.year;
          let yearShown = 0;
          year.months.forEach((month) => {
            let monthShown = 0;
            month.entries.forEach((entry) => {
              const matches = yearMatches && (!query || entry.title.includes(query) || entry.source.includes(query));
              entry.element.hidden = !matches;
              if (matches) monthShown += 1;
            });
            month.element.hidden = monthShown === 0;
            if (clearDisclosure) month.element.open = false;
            if (query && monthShown > 0) month.element.open = true;
            yearShown += monthShown;
          });
          year.element.hidden = yearShown === 0;
          if (clearDisclosure) year.element.open = selectedYear !== 'all' && yearMatches;
          if (query && yearShown > 0) year.element.open = true;
          shown += yearShown;
        });
        yearButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.dmmaYear === selectedYear)));
        status.textContent = root.dataset.resultMessage.replace('__SHOWN__', String(shown)).replace('__TOTAL__', String(total));
        empty.hidden = shown !== 0;
        previousQuery = query;
        syncExpand();
      };
      const reset = (focusSearch = false) => {
        search.value = '';
        selectedYear = 'all';
        apply(true);
        if (focusSearch) search.focus();
      };
      yearButtons.forEach((button) => button.addEventListener('click', () => {
        selectedYear = button.dataset.dmmaYear;
        apply(true);
      }));
      root.querySelectorAll('[data-dmma-query]').forEach((button) => button.addEventListener('click', () => {
        selectedYear = 'all';
        search.value = button.dataset.dmmaQuery;
        apply(true);
      }));
      root.querySelector('[data-dmma-reset]').addEventListener('click', () => reset());
      root.querySelector('[data-dmma-empty-reset]').addEventListener('click', () => reset(true));
      search.addEventListener('input', () => apply());
      expand.addEventListener('click', () => {
        const details = visibleDetails();
        const shouldOpen = !details.every((element) => element.open);
        details.forEach((element) => { element.open = shouldOpen; });
        syncExpand();
      });
      root.addEventListener('toggle', syncExpand, true);
      apply(true);
      controls.hidden = false;
    };
    const initializeWithin = (container) => {
      if (container.matches?.('[data-dm-memory-archive]')) initialize(container);
      container.querySelectorAll('[data-dm-memory-archive]').forEach(initialize);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
    } else {
      initializeWithin(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deepmoat-memory-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.memoryInitialized) return;
      root.dataset.memoryInitialized = 'true';
      const revealHash = () => {
        const target = [...root.querySelectorAll('article')].find((card) => '#' + card.id === window.location.hash);
        if (target) {
          target.querySelector('details').open = true;
          target.scrollIntoView({ block: 'start' });
        }
      };
      window.addEventListener('hashchange', revealHash);
      let printState = [];
      window.addEventListener('beforeprint', () => {
        printState = [...root.querySelectorAll('details')].map((detail) => [detail, detail.open]);
        printState.forEach(([detail]) => { detail.open = true; });
      });
      window.addEventListener('afterprint', () => {
        printState.forEach(([detail, wasOpen]) => { detail.open = wasOpen; });
      });
      const printButton = root.querySelector('[data-memory-print]');
      printButton.hidden = false;
      printButton.addEventListener('click', () => window.print());
      revealHash();
    };
    const initializeWithin = (container) => {
      if (container.matches?.('[data-dm-memory-story]')) initialize(container);
      container.querySelectorAll('[data-dm-memory-story]').forEach(initialize);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
    else initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
